
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Modal } from 'office-ui-fabric-react/lib/Modal';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { PrimaryButton, IconButton } from 'office-ui-fabric-react/lib/Button';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';

import Text from '../../common/client/components/Text';

import analyzeGetActions from '../../sagas/analyze';
import { getSelectedTel } from '../../reducers/analyze';

import OverviewTitle from './OverviewTitle';

const classNames = mergeStyleSets({
    root: {
        padding: 16
    },
    title: {
        paddingBottom: 16
    },
    content: {
        paddingRight: 8,
        marginBottom: 8,
    },
    closeIcon: {
    }
});

const CheckboxTel = ({tel, checked, onChange}) => {

    const handleChange = (e, value) => {
        if (onChange) {
            onChange(e, value, tel);
        }
    }

    return (
        <Stack horizontal tokens={{childrenGap: 8}}>
            <Checkbox
                checked={checked}
                onChange={handleChange}
            />
            <Text bold>{tel.katuze_nazev}</Text>
            <Text>({tel.katuze_kod})</Text>
            <Text>- Číslo LV:</Text>
            <Text bold>{tel.cislo_tel}</Text>
        </Stack>
    )
}

const SelectLvDialog = ({open, onDismiss, analyzeData}) => {

    const dispatch = useDispatch();
    const analyzeActions = analyzeGetActions(dispatch);

    const selectedTel = useSelector(state => getSelectedTel(state.analyze));

    const handleChange = (e, value, tel) => {
        analyzeActions.setSelectedTel(tel.tel_id, value);
    }

    return (
        <Modal
            className={classNames.root}
            isOpen={open}
            isModeless={false}
            isDarkOverlay={true}
            dragOptions={false}
            onDismiss={onDismiss}
        >
            <Stack className={classNames.root}>
                <Stack horizontal className={classNames.title}>
                    <Stack.Item grow>
                        <OverviewTitle title={`Výběr listu vlastnictví`} />
                    </Stack.Item>
                    <IconButton
                        styles={classNames.closeIcon}
                        iconProps={{iconName: 'Cancel'}}
                        ariaLabel="Zavřít"
                        onClick={onDismiss}
                    />
                </Stack>
                <Stack.Item className={classNames.content}>
                    <Stack tokens={{childrenGap: 4}}>
                        {selectedTel.map(item => {
                            return (
                                <CheckboxTel
                                    key={item.tel_id}
                                    tel={item}
                                    checked={item.selected}
                                    onChange={handleChange}
                                />
                            )
                        })}
                    </Stack>
                </Stack.Item>
                <Stack horizontal reversed>
                    <PrimaryButton text="Zavřít" onClick={onDismiss} />
                </Stack>
            </Stack>
        </Modal>
    );
}

export default SelectLvDialog;
